import React, { useEffect, useRef, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase.js";
import LandingPageTopNav from "../LandingPageTopNav";
import LandingPageFooter from "../LandingPageFooter";
import BeforeAfterSection from "./components/sections/BeforeAfterSection";
import PresentScreenMockSection from "./components/sections/PresentScreenMockSection";
import AutomationTimelineSection from "./components/sections/AutomationTimelineSection";
import ConsistencySection from "./components/sections/ConsistencySection";
import UseExistingResourcesSection from "./components/sections/UseExistingResourcesSection";
import ToolsWidgetsSection from "./components/sections/ToolsWidgetsSection";
import ClassroomExamplesSection from "./components/sections/ClassroomExamplesSection";
import ClassStylesSection from "./components/sections/ClassStylesSection";
import TestimonialsEditorialSection from "./components/sections/TestimonialsEditorialSection";
import PricingSection from "./components/sections/PricingSection";
import FaqSection from "./components/sections/FaqSection";
import FinalCtaSection from "./components/sections/FinalCtaSection";
import "./landing-v2.css";

const scrollToElement = (ref) => {
  if (ref?.current) {
    ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const scrollToPageTop = () => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  window.scrollTo({
    top: 0,
    behavior: prefersReducedMotion ? "auto" : "smooth",
  });
};

const LandingPage = () => {
  const pricingRef = useRef(null);
  const faqRef = useRef(null);
  const howItWorksRef = useRef(null);
  const heroMockRef = useRef(null);
  const [pricingData, setPricingData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchPricing = async () => {
      try {
        const docRef = doc(db, "dynamicData", "tqZ8VusxvnaBEQRoDTeW");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists() && isMounted) {
          setPricingData(docSnap.data().pricingData);
        }
      } catch (error) {
        console.error("Error fetching pricing:", error);
      }
    };

    fetchPricing();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, []);

  return (
    <div className="landing-v2">
      <LandingPageTopNav
        scrollToFeatures={() => scrollToElement(howItWorksRef)}
        scrollToPricing={() => scrollToElement(pricingRef)}
        scrollToFaq={() => scrollToElement(faqRef)}
      />

      <main>
        <PresentScreenMockSection previewContainerRef={heroMockRef} />
        <div ref={howItWorksRef} id="how-it-works">
          <AutomationTimelineSection />
        </div>
        <ConsistencySection />
        <UseExistingResourcesSection />
        <ToolsWidgetsSection />
        <ClassroomExamplesSection
          onScrollToHowItWorks={() => scrollToElement(howItWorksRef)}
        />
        <BeforeAfterSection />
        <ClassStylesSection />
        <TestimonialsEditorialSection />
        <PricingSection
          pricingData={pricingData}
          pricingRef={pricingRef}
          onOpenDemo={() => scrollToElement(heroMockRef)}
        />
        <FaqSection faqRef={faqRef} />
        <FinalCtaSection />
      </main>

      <LandingPageFooter onLandingPage />
      <button
        type="button"
        className="landing-v2__back-to-top"
        onClick={scrollToPageTop}
        aria-label="Back to top"
      >
        <i className="fa fa-arrow-up" aria-hidden="true" />
      </button>
    </div>
  );
};

export default LandingPage;
